import PostsCustomer from "./PostCustomer/posts";
import { Outlet, useParams } from "react-router-dom";

const Tab4 = () => {
  const { Id } = useParams();

  return Id ? <Outlet /> : <PostsCustomer />;
};

export default Tab4;
